export const formatName = (name) => name.trim().toUpperCase();
/** "Jordan" + "Smith" -> "Jordan S."; falls back to the email when there's no first name. */
export function firstNameLastInitial(user) {
    const last = user.lastName?.trim();
    return [user.firstName || user.email || '', last ? `${last[0]}.` : ''].filter(Boolean).join(' ');
}
